<div class="xux-form-list-container" *ngIf="showForm">
  <div data-e2e-id="xux-list-container" class="xux-list-container">
    <xux-document-info-error-message
      *ngIf="isDocumentInfoMessageShow$ | async"
      [messageData]="infoMessageData$ | async"
    ></xux-document-info-error-message>
    <div class="xux-top-panel">
      <div data-e2e-id="xux-list-title" class="title-area">
        <h4>
          {{ headerName | translate }}
          <xux-tooltip-icon
            *ngIf="titleTooltipIconConfig$ | async"
            [config]="titleTooltipIconConfig$ | async"
            class="ws-connection-icon orange"
          ></xux-tooltip-icon>
        </h4>
        <div class="sub-info-box">
          <span class="sub-info" *ngIf="!disableItemsCountLabel">
            {{ I18n.Forms.GridMessages.ShowingEntities | translate: { count:
            pageSideTotal || 0, entities: listTotalItemsLabel$ | async } }}
          </span>
        </div>
      </div>
      <div class="xux-buttons-area">
        <!-- Main buttons -->
        <div *ngIf="mainGridButtons">
          <div
            *ngFor="let button of mainGridButtons"
            class="xux-dropdown btn-group pull-right"
          >
            <button
              type="button"
              [disabled]="!formListGroup.dirty || formListGroup.invalid || (button.disabledObs | async) || (!canManage && !canAdd)"
              [ngClass]="button.class"
              data-e2e-id="save-form-list-changes-btn"
              class="btn btn-default btn-primary"
              (click)="handleClick(button)"
            >
              {{ button.caption | translate }}
            </button>

            <ng-container *ngIf="button.childItems">
              <button
                type="button"
                class="btn btn-default btn-primary dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-e2e-id="edit-xux-btn-toggle-dropdown"
              >
                <i class="glyphicon glyphicon-menu-down"></i>
                <span class="sr-only">Toggle Dropdown</span>
              </button>
              <ul class="dropdown-menu">
                <li *ngFor="let childBtn of button.childItems">
                  <a
                    *ngIf="!childBtn.hidden"
                    [class.disabled]="
                        (childBtn.disabledObs && (childBtn.disabledObs | async))
                        || (childBtn.applyManagePermissionToHide && !canManage && !canAdd)"
                    [ngClass]="childBtn.class"
                    (click)="handleClick(childBtn)"
                  >
                    <span>{{ childBtn.caption | translate }}</span>
                  </a>
                </li>
              </ul>
            </ng-container>
          </div>
        </div>
      </div>

      <xvi-xux-datepicker-area
        *ngIf="showCalendar"
        [calendarConfig]="calendarConfig"
        [calendarValue]="calendarValue"
        [label]="datepickerLabel"
        (dateChange)="onDateChange($event)"
      ></xvi-xux-datepicker-area>

    </div>
    <xvi-label
      *ngIf="warningMessage$|async"
      [title]="warningMessage$| async "
      [itemClass]="warningLabelClass"
    ></xvi-label>
    <xux-grid
      #listGrid
      *ngIf="!useCustomGrid"
      xviAgGridKeyboardNav
      [xviNavOptions]="navigationOptions"
      [xviNavEnabled]="enableGridNavigate"
      class="xux-list"
      [class.show-deleted-mode]="inShowDeletedMode"
      [ngClass]="classes"
      [class.disabled]="disabled"
      data-e2e-id="xux-list"
      [items]="items$ | async"
      [columns]="columnDefinitions"
      [view]="viewConfig"
      [options]="gridOptions"
      [buttons]="actionButtons"
      [rowButtons]="rowActionButtons"
      [showLoader]="getIsShowLoad() | async"
      [userComponents]="xviCustomGridComponents"
      [pageCount]="pageCount$ | async"
      [userGridOptions]="userGridOptions"
      [i18n]="staticI18nTextContent.xuxGrid"
      (action)="onGridAction($event)"
    >
    </xux-grid>
    <xux-grid-custom
      #listGrid
      *ngIf="useCustomGrid"
      xviAgGridKeyboardNav
      [xviNavOptions]="navigationOptions"
      [xviNavEnabled]="enableGridNavigate"
      class="xux-list"
      [class.show-deleted-mode]="inShowDeletedMode"
      [ngClass]="classes"
      [class.disabled]="disabled"
      data-e2e-id="xux-list"
      [items]="items$ | async"
      [columns]="columnDefinitions"
      [view]="viewConfig"
      [options]="gridOptions"
      [buttons]="actionButtons"
      [rowButtons]="rowActionButtons"
      [showLoader]="getIsShowLoad() | async"
      [userComponents]="xviCustomGridComponents"
      [pageCount]="pageCount$ | async"
      [userGridOptions]="userGridOptions"
      [i18n]="staticI18nTextContent.xuxGrid"
      (action)="onGridAction($event)"
    >
    </xux-grid-custom>
  </div>
</div>
